import { Tabs, Tab } from '@mui/material'

import styles from './tabStyle.module.scss'

export default function TabCustom({
	innerTab = 0,
	onInnerTabChange = () => {},
	tabData = [],
}) {
	const innerTabStyle = {
		'&.MuiTabs-root': {
			minHeight: 'unset',
			backgroundColor: '#F2F6F8',
			padding: '2px 4px',
			borderRadius: '10px',
		},
		'& .MuiTabs-scroller': {
			padding: '2px 0',
		},

		'& .MuiButtonBase-root': {
			padding: '8px',
			minHeight: 'unset',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#8692A4',
			textTransform: 'capitalize',
			minWidth: ' auto !important',

			'&.Mui-selected': {
				color: '#7CA6BD',
				backgroundColor: '#fff',
				borderRadius: '8px',
				boxShadow: '0px 1px 3px 0px #0000001A',
				minWidth: ' auto !important',

				'& svg path': {
					stroke: '#7CA6BD',
				},
			},
		},
		'& .MuiTabs-indicator': {
			backgroundColor: 'transparent',
		},
		'@media (max-width: 599px)': {
			'& .MuiButtonBase-root': {
				padding: '8px',
			},
		},
	}
	return (
		<div className={styles.tabRow}>
			<div className={styles.tabBtns}>
				<Tabs
					value={innerTab}
					onChange={onInnerTabChange}
					aria-label="basic tabs example"
					sx={innerTabStyle}
				>
					{tabData.map(({ tabIcon, tabLabel }, index) => (
						<Tab
							key={index}
							label={
								<div className={styles.tabItem}>
									{tabIcon}
									<span>{tabLabel}</span>
								</div>
							}
						/>
					))}
				</Tabs>
			</div>
		</div>
	)
}
